import script from "./FileConstructionConent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileConstructionConent.vue?vue&type=script&lang=ts&setup=true"

import "./FileConstructionConent.vue?vue&type=style&index=0&id=694e901d&lang=css"

const __exports__ = script;

export default __exports__